// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { bonesDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/bonesDeclaration";
import { bakedVertexAnimationDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/bakedVertexAnimationDeclaration";
import { instancesDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/instancesDeclaration";
import { clipPlaneVertexDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/clipPlaneVertexDeclaration";
import { logDepthDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/logDepthDeclaration";
import { fogVertexDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/fogVertexDeclaration";
import { lightVxFragmentDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/lightVxFragmentDeclaration";
import { lightVxUboDeclarationWGSL } from "core/ShadersWGSL/ShadersInclude/lightVxUboDeclaration";
import { instancesVertexWGSL } from "core/ShadersWGSL/ShadersInclude/instancesVertex";
import { bonesVertexWGSL } from "core/ShadersWGSL/ShadersInclude/bonesVertex";
import { bakedVertexAnimationWGSL } from "core/ShadersWGSL/ShadersInclude/bakedVertexAnimation";
import { clipPlaneVertexWGSL } from "core/ShadersWGSL/ShadersInclude/clipPlaneVertex";
import { logDepthVertexWGSL } from "core/ShadersWGSL/ShadersInclude/logDepthVertex";
import { fogVertexWGSL } from "core/ShadersWGSL/ShadersInclude/fogVertex";
import { shadowsVertexWGSL } from "core/ShadersWGSL/ShadersInclude/shadowsVertex";

const name = "normalVertexShader";
const shader = `attribute position: vec3f;
#ifdef NORMAL
attribute normal: vec3f;
#endif
#ifdef UV1
attribute uv: vec2f;
#endif
#ifdef UV2
attribute uv2: vec2f;
#endif
#ifdef VERTEXCOLOR
attribute color: vec4f;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
uniform view: mat4x4f;uniform viewProjection: mat4x4f;
#ifdef DIFFUSE
varying vDiffuseUV: vec2f;uniform diffuseMatrix: mat4x4f;uniform vDiffuseInfos: vec2f;
#endif
#ifdef POINTSIZE
uniform pointSize: f32;
#endif
varying vPositionW: vec3f;
#ifdef NORMAL
varying vNormalW: vec3f;
#endif
#include<clipPlaneVertexDeclaration>
#include<logDepthDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#if defined(CLUSTLIGHT_BATCH) && CLUSTLIGHT_BATCH>0
varying vViewDepth: f32;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input : VertexInputs)->FragmentInputs {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
var worldPos: vec4f=finalWorld* vec4f(vertexInputs.position,1.0);vertexOutputs.position=uniforms.viewProjection*worldPos;vertexOutputs.vPositionW= worldPos.xyz;
#ifdef NORMAL
vertexOutputs.vNormalW=normalize(( finalWorld* vec4f(vertexInputs.normal,0.0)).xyz);
#endif
#ifndef UV1
var uv: vec2f= vec2f(0.,0.);
#else
var uv: vec2f=vertexInputs.uv;
#endif
#ifndef UV2
var uv2: vec2f= vec2f(0.,0.);
#else
var uv2: vec2f=vertexInputs.uv2;
#endif
#ifdef DIFFUSE
if (uniforms.vDiffuseInfos.x==0.)
{vertexOutputs.vDiffuseUV=(uniforms.diffuseMatrix* vec4f(uv,1.0,0.0)).xy;}
else
{vertexOutputs.vDiffuseUV=(uniforms.diffuseMatrix* vec4f(uv2,1.0,0.0)).xy;}
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
const includes = [bonesDeclarationWGSL, bakedVertexAnimationDeclarationWGSL, instancesDeclarationWGSL, clipPlaneVertexDeclarationWGSL, logDepthDeclarationWGSL, fogVertexDeclarationWGSL, lightVxFragmentDeclarationWGSL, lightVxUboDeclarationWGSL, instancesVertexWGSL, bonesVertexWGSL, bakedVertexAnimationWGSL, clipPlaneVertexWGSL, logDepthVertexWGSL, fogVertexWGSL, shadowsVertexWGSL];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStoreWGSL[inc.name]) {
        ShaderStore.IncludesShadersStoreWGSL[inc.name] = inc.shader;
    }
}

/** @internal */
export const normalVertexShaderWGSL = { name, shader };
